// extracted by mini-css-extract-plugin
module.exports = {"root":"chip_root__A7QWh","primary":"chip_primary__I2fzI","secondary":"chip_secondary__2RKoH","small":"chip_small__2g6gl","medium":"chip_medium__3ZtXT","large":"chip_large__cTeL0"};